export default Object.prototype.hasOwnProperty;